module.exports = __webpack_public_path__ + "static/open-sans-bold-fc0dbb2edfac9ef855bcc6acd9e3477d.eot";